import type { FC } from "react";

import { Card, type GridCard } from "widgets";

import { ProteinTile } from "../../core/tiles/index.js";
import { getSourceString } from "@/app-utils/string.ts";
import type { Protein } from "@/graphql.ts";
import { SelMessage } from "@/messages/SelMessage.tsx";

export interface IProteinListCardProps extends GridCard {
  proteins: Protein[];
  ignoreIfEmpty?: boolean;
  title?: string;
  showSource?: boolean;
}

export function displayIdentifier(protein: Protein) {
  return protein.systematicName ? protein.systematicName : protein.accession;
}

const ProteinListCard: FC<IProteinListCardProps> = (props) => {
  const proteins: Protein[] = props.proteins;
  if (props.ignoreIfEmpty && (!proteins || proteins.length === 0)) {
    return null;
  }

  let elements: JSX.Element | JSX.Element[] = <SelMessage id={"noContent.relatedProteins"} />;

  if (proteins && proteins.length > 0) {
    elements = proteins.map((protein: Protein) => {
      const sourceHint = props.showSource ? getSourceString(protein.genome, protein.database) : undefined;
      return (
        <ProteinTile
          protein={protein}
          key={`protein-card-elem-${protein.id}`}
          footNote={sourceHint}
          hideIcon
          type={null}
        />
      );
    });
  }

  return (
    <Card title={props.title ?? "Proteins"} tag={{ label: String(proteins.length) }}>
      {elements}
    </Card>
  );
};

export { ProteinListCard };
